import { useRouter } from 'vue-router'

import { useSiteInfoStore } from 'src/stores/site-info'
import { externalLinkMessageToApp } from 'src/common/webview'

const isOwnSport = !!process.env.OWN_SPORT

export function useGoToLink() {
  const router = useRouter()
  const siteInfoStore = useSiteInfoStore()

  function goToLink(link) {
    if (link.startsWith('http')) {
      if (siteInfoStore.isWebView) {
        return externalLinkMessageToApp(link)
      }
      return window.open(link, '_blank')
    }

    const resolvedRoute = router.resolve(link)

    // условие для БК ссылки
    if (isOwnSport) {
      if (resolvedRoute.name === '404page') {
        const withCasResolved = router.resolve('/casino' + link)
        if (withCasResolved.name !== '404page') {
          return router.push(withCasResolved).catch(() => {})
        }
      }
    }

    router.push(resolvedRoute).catch(() => {})
  }

  return {
    goToLink,
  }
}
